import { getStoryCalendarByCompanyMeta, getStoryCalendarByCompanyPayload } from 'types/store/getStoryCalendarByCompanyState';
import { createAsyncReducer } from 'utils/Redux';

import { getStoryCalendarByCompanyActions } from '../actions';

export default createAsyncReducer<getStoryCalendarByCompanyMeta, getStoryCalendarByCompanyPayload>(getStoryCalendarByCompanyActions);
